import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// import { isSignInWithEmailLink, signInWithEmailLink} from 'firebase/auth';
// import { auth } from '../../auth/firebase';
import { useGetAuthUser, useCompleteSignIn } from "../../hooks/authhooks";
// import { useAuthState } from "../../contexts/authcontext";
import FinishSignInSkeleton from "../../components/FinishSignInSkeleton"
import { getLastPagePathFromAccessToken, getUIDFromAccessToken } from '../../utils/helpers';
// import {  } from '../../hooks/authhooks'
// import { getEmailFromAccessToken } from '../../utils/helpers';
// import { signInWithCustomToken } from 'firebase/auth'; 

const FinishSignIn: React.FC = () => {
  const navigate = useNavigate();
  const loginTokenFromStorage = localStorage.getItem('login_token');
  const { login_token: pathLoginToken } = useParams()
  const extractLoginTokenFromUrl = (urlString: string | null) => {
    if (!urlString) return null;
    try {
      const url = new URL(urlString);
      // 1) Query param
      const q = url.searchParams.get('login_token');
      if (q) return q;
      // 2) Path segment after finishSignIn
      const segments = url.pathname.split('/').filter(Boolean);
      const idx = segments.indexOf('finishSignIn');
      if (idx >= 0 && segments[idx + 1] && segments[idx + 1] !== 'finishSignIn') {
        return segments[idx + 1];
      }
      // 3) Hash checks: pattern '#/finishSignIn/<token>' or '#login_token=<token>'
      const hash = url.hash?.replace(/^#/, '') || '';
      if (hash) {
        try {
          const hashAsUrl = new URL(hash, url.origin);
          const hq = hashAsUrl.searchParams.get('login_token');
          if (hq) return hq;
          const hSegs = hashAsUrl.pathname.split('/').filter(Boolean);
          const hIdx = hSegs.indexOf('finishSignIn');
          if (hIdx >= 0 && hSegs[hIdx + 1]) return hSegs[hIdx + 1];
        } catch {
          const m = hash.match(/login_token=([^&]+)/);
          if (m && m[1]) return decodeURIComponent(m[1]);
          const parts = hash.split('/');
          const fIdx = parts.indexOf('finishSignIn');
          if (fIdx >= 0 && parts[fIdx + 1]) return parts[fIdx + 1];
        }
      }
    } catch {
      // not a valid URL
    }
    return null;
  };

  const queryLoginToken = extractLoginTokenFromUrl(window.location.href);

  const continueUrlToken = (() => {
    try {
      const url = new URL(window.location.href);
      const cont = url.searchParams.get('continueUrl');
      if (!cont) return null;
      let decodedStr = decodeURIComponent(cont);
      try { decodedStr = decodeURIComponent(decodedStr); } catch {}
      return extractLoginTokenFromUrl(decodedStr);
    } catch {
      return null;
    }
  })();

  const effectiveLoginToken = pathLoginToken || queryLoginToken || continueUrlToken || loginTokenFromStorage;
  if (effectiveLoginToken && !loginTokenFromStorage) {
    try { localStorage.setItem('login_token', effectiveLoginToken); } catch {}
  }
  var tokenUid: string = getUIDFromAccessToken(effectiveLoginToken)
  
  const lastPagePathFromStorage = localStorage.getItem('lastPagePath');
  const lastPagePath: string = lastPagePathFromStorage ? lastPagePathFromStorage : getLastPagePathFromAccessToken(effectiveLoginToken)
  
  const { authUser, isLoadingAuthUser } = useGetAuthUser(tokenUid)
  var error = ""
  const email = authUser?.email

  // if (!email && !isLoadingAuthUser) {
  //   // console.log('Please provide your email for confirmation');
  //   error = `Please provide your email for confirmation`
  //   // setError("Please provide your email for confirmation")
  // } else 

  const {completeSignInWithEmailLink, user, isLoading} = useCompleteSignIn()

  // get current page url from local storage
  // const currentPageUrl = localStorage.getItem('currentPageUrl');
  
  // console.log('currentPageUrl', currentPageUrl);
  // console.log('lastPagePath', lastPagePath);
  const redirectPath = lastPagePath ? lastPagePath : '/';
  const finishSignInURL = (() => {
    const raw = window.location.href;
    try {
      const url = new URL(raw);
      // Remove path segment token if present
      if (pathLoginToken) {
        const segments = url.pathname.split('/').filter(Boolean);
        const filteredSegments = segments.filter(segment => segment !== pathLoginToken);
        url.pathname = '/' + filteredSegments.join('/');
      }
      // Remove query param token if present
      if (url.searchParams.has('login_token')) {
        url.searchParams.delete('login_token');
      }
      // Sanitize continueUrl if it contains the token
      const cont = url.searchParams.get('continueUrl');
      if (cont) {
        try {
          let dec = decodeURIComponent(cont);
          try { dec = decodeURIComponent(dec); } catch {}
          const decoded = new URL(dec);
          const tokenToStrip = effectiveLoginToken || pathLoginToken || queryLoginToken || continueUrlToken;
          if (tokenToStrip) {
            // Remove token from path
            const segs = decoded.pathname.split('/').filter(Boolean);
            const filtered = segs.filter(s => s !== tokenToStrip);
            decoded.pathname = '/' + filtered.join('/');
            // Remove token from query
            if (decoded.searchParams.get('login_token') === tokenToStrip) {
              decoded.searchParams.delete('login_token');
            }
          }
          url.searchParams.set('continueUrl', encodeURIComponent(decoded.toString()));
        } catch {}
      }
      return url.toString();
    } catch (e) {
      return pathLoginToken ? raw.replace(`/${pathLoginToken}`, '') : raw;
    }
  })();
  // const finishSignInURL = window.location.href;
  const hasCompletedRef = React.useRef(false);

  React.useEffect(() => {
    if (hasCompletedRef.current) return;
    if (!isLoadingAuthUser && email) {
      hasCompletedRef.current = true;
      completeSignInWithEmailLink(email, finishSignInURL).then(() => {
        navigate(redirectPath);
      }).catch(() => {
        hasCompletedRef.current = false;
      });
    }
  }, [email, isLoadingAuthUser, finishSignInURL, navigate, redirectPath, completeSignInWithEmailLink]);

  // console.log("pathLoginToken", pathLoginToken)
  // console.log("queryLoginToken", queryLoginToken)
  // console.log("loginTokenFromStorage", loginTokenFromStorage)
  // console.log("tokenUid", tokenUid)
  // console.log("lastPagePath", lastPagePath)
  // console.log('user', user);
  // console.log('error', error);

   if ((isLoadingAuthUser || isLoading) && !user){
    return (
      <FinishSignInSkeleton />
    )
  } else if (error) {
    return (
      <div className='items-center h-full w-full my-auto p-auto text-primaryDark-200 text-lg flex flex-col align-middle text-center justify-center pt-40'>
        <p className='font-bold'>Error with sign-in</p>
        <p className='text-md'>{error ? error : 'Error with sign-in, please provide valid email for confirmation'}</p>
      </div>
    )
  } else if (user){
    return (
      <div className='items-center h-full w-full my-auto p-auto text-primaryDark-200 text-lg flex flex-col align-middle text-center justify-center pt-40'>
        Completed sign-in
      </div>)
  } else if (!isLoading || !isLoadingAuthUser){
    return (
      <div className='items-center h-full w-full my-auto p-auto text-primaryDark-200 flex flex-col align-middle text-center justify-center pt-40'>
        <p className='font-bold text-lg'>Cannot complete sign-in with link</p>
        <p className='text-md'>Please provide valid email</p>
        <FinishSignInSkeleton />
      </div>)
  }

  return (
    <div className='items-center h-full w-full my-auto p-auto text-primaryDark-200 flex flex-col align-middle text-center justify-center pt-40'>
      Completing sign-in...
    </div>)
  
};

export default FinishSignIn;